import { CSSProperties } from 'react';
import { Box, TooltipProps } from '@/primitives';
import { ROUTE_SEGMENT } from '@/constants/routeSegments';
import { HyperLink } from '@/components/publicSearch/resultCell/HyperLink';
import { isMemberDetailsLinkable } from '@/components/publicSearch/member/memberDetailsLink';

type TProps = {
  detailsAvailFlag?: string | null;
  linkStyle?: CSSProperties;
  memberDisplayName: string;
  memberId: number;
  orgName: string;
  tooltipPlacement?: TooltipProps['placement'];
};

export default function MemberInlineDisplay(props: TProps) {
  const label = props.memberDisplayName || 'unknown';

  if (!isMemberDetailsLinkable(props.detailsAvailFlag)) {
    // Match the linked (HyperLink) label's font size and padding so linked and
    // unlinked breeder/owner names align row-to-row — just without the link
    // colour/affordance. (Previously this used the larger `bodylarge` variant
    // with no padding, so unlinked names looked bigger and sat flush.)
    return (
      <Box
        component="span"
        sx={{
          color: 'text.secondary',
          display: 'inline-block',
          py: 0.5,
          px: 1.25,
          minWidth: 0,
          overflow: 'hidden',
          wordBreak: 'break-word',
          ...props.linkStyle,
        }}
      >
        {label}
      </Box>
    );
  }

  const pathname = `/${props.orgName}/${ROUTE_SEGMENT.MEMBERS}/${props.memberId}`;

  return (
    <HyperLink
      label={label}
      linkStyle={props.linkStyle}
      pathname={pathname}
      tooltipPlacement={props.tooltipPlacement ?? 'bottom'}
    />
  );
}
